import { Link, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import AuthLayout from "./AuthLayout";
import { FormInput, VerticalForm } from "../../components/Form";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, userProfile } from "../../store/user/userThunk";
import { useEffect } from "react";
import Cookies from "js-cookie";
import swal from "sweetalert";
import { resertloginerrer, resetAuth, resetProfile } from "../../store/user/userSlice";
import { toast } from "react-toastify";
/*
form validation schema
*/
const schemaResolver = yupResolver(
  yup.object().shape({
    email: yup
      .string()
      .required('Please enter Email')
      .email('Please enter a valid Email address'),

    password: yup
      .string()
      .required('Please enter Password')
      .min(8, 'Password must be at least 8 characters')
      .max(32, 'Password must be at most 32 characters')
      .matches(/[a-z]/, 'Password must include at least one lowercase letter')
      .matches(/[A-Z]/, 'Password must include at least one uppercase letter')
      .matches(/\d/, 'Password must include at least one number')
      .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must include at least one special character'),
  })
);


const BottomLink = () => {
  return (
    <div className="w-full text-center">
      <p className="text-gray-500 leading-6 text-base">
        Don't have an account?{" "}
        <Link to="/auth/sign-up" className="text-primary font-semibold ms-1">
          Sign Up
        </Link>
      </p>
    </div>
  );
};

// Define handleSubmit for form submission

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let {
    loading,
    lgerror,
    isAuthenticated,
    token,
    profile,
    Verifyerror,
    disableStatus,
  } = useSelector((state) => state.userservice);

const handleSubmit = async (data) => {
  console.log(data);
  
  dispatch(loginUser(data))
    .unwrap()
    .then((loginRes) => {
      console.log(loginRes, "loginUserloginUserresss");
      
      if (loginRes) {
        return dispatch(userProfile()).unwrap();
      } else {
        throw new Error("Login failed");
      }
    })
    .then((profileResult) => {
      console.log(profileResult, "userProfileuserProfileresult");
      
      if (profileResult) {
        if (profileResult.is2FAEnabled === true) {
          // toast.success('Login Successfull')

          navigate("/auth/2fa-verify");
        } else if (profileResult.iglogin === true || 
                  profileResult.wpLogin === true || 
                  profileResult.Fblogin === true) {
          navigate("/dashboards");
        } else {
          navigate("/Settings");
        }
      } else {
        throw new Error("Failed to retrieve profile");
      }
    })
    .catch((error) => {
      console.log(error, "Error in authentication process");
      // You can uncomment this if you want to show error toast
      // toast.error(error.message || "Authentication failed");
      dispatch(resetAuth());
    });
};

  // useEffect(() => {
  //   if (isAuthenticated === true) {
  //     swal({
  //       title: "Login Successfull",
  //       text: "You have successfully logged in!",
  //       icon: "success",
  //       position: "top",
  //       showConfirmButton: false,
  //       timer: 3000,
  //     });

  //     Cookies.set("token", token?.message);
  //     dispatch(resetAuth());
  //     if (profile === null) {
  //       // getuserprofile()
    
  //     }

  //     // dispatch(resetAuth());
  //   }
  // }, [isAuthenticated]);


  

  let getuserprofile = async () => {
    await dispatch(userProfile());
  };

  // useEffect(() => {
  //   if (lgerror) {
  //     swal({
  //       title: "login Error",
  //       text: lgerror?.message,
  //       icon: "error",
  //       position: "top",
  //       showConfirmButton: true,
  //     });

  //   }
  //   dispatch(resertloginerrer())
  // }, [lgerror]);
  return (
    <AuthLayout
      authTitle="Welcome back!"
      helpText="Enter your email address and password to access admin panel."
      bottomLinks={<BottomLink />}
    >
      <VerticalForm
        onSubmit={handleSubmit} // Updated here
        resolver={schemaResolver}
      // defaultValues={{ email: 'prompt@coderthemes.com', password: 'prompt' }}
      >
        <FormInput
          name="email"
          type="email"
          label="Email"
          labelClassName="block text-sm font-medium mb-1 text-gray-600"
          className="py-2 px-4 leading-6 block w-full border-gray-300 rounded text-sm focus:border-gray-300 focus:ring-0"
          containerClass="mb-4"
          placeholder="Enter Your Email"
          required
        />

        <FormInput
          label="Password"
          type="password"
          name="password"
          placeholder="Enter your password"
          className="py-2 px-4 leading-6 block w-full border-gray-300 rounded rounded-e-none text-sm focus:border-gray-300 focus:ring-0"
          containerClass="mb-4"
          labelClassName="block text-sm font-medium mb-1 text-gray-600"
          labelContainerClassName="flex justify-between items-center mb-0"
          required
        >
          <Link
            to="/auth/recoverpw"
            className="float-right text-gray-500 text-xs border-b border-dashed pb-1 ms-1"
          >
            Forgot your password?
          </Link>
        </FormInput>
        <div className="mb-0 text-center">
          <button
            className="w-full bg-primary text-white font-medium leading-6 text-center align-middle select-none py-2 px-4 text-base rounded-md transition-all hover:shadow-lg hover:shadow-primary/30"
            type="submit"
          >
            Log In
          </button>
        </div>
      </VerticalForm>
    </AuthLayout>
  );
};

export default Login;
